import React from "react";

export default function ObbyGiftCards() {
  return (
    <div>
      <h2 id="obby-gift-cards">Obby Gift Cards</h2>
      <div>
        <ol>
          <li>
            <p>
              Obby Gift Cards are issued by Obby. You may only redeem an Obby
              Gift Card against Obby for Orders placed online through the
              Website for Services. This means that we will reduce the purchase
              price payable for the Services or by the equivalent value on your
              Obby Gift Card. If the purchase price of Services is less than the
              value of your Obby Gift Card, any remaining balance on your Obby
              Gift Card can be used towards a further purchase until the balance
              reaches £0.
            </p>
          </li>
          <li>
            <p>Obby Gift Cards are only cancellable as follows:</p>
            <ol type="a">
              <li>
                <p>
                  A refund of the applicable amount via the original method of
                  payment is possible if you cancel (in whole or in part) an
                  Obby Gift Card within 24 hours of receiving your Order
                  Confirmation, provided you have not already used it to redeem
                  against a booking.
                </p>
              </li>
              <li>
                <p>
                  If permitted by these Booking Terms and Conditions and the
                  relevant Partner Terms and Conditions, cancellations of Obby
                  Gift Cards must be made by one of the following methods:
                </p>
                <ul>
                  <li>
                    <p>Dated bookings</p>
                  </li>
                  <li>
                    <p>
                      Following the link in your Order Confirmation email; or
                    </p>
                  </li>
                  <li>
                    <p>
                      Emailing our Customer Care team on{" "}
                      <a href="mailto:hello@obby.co.uk">hello@obby.co.uk</a>.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  No refund will be given where a cancellation is attempted more
                  than 24hrs after receiving your Order Confirmation.
                </p>
              </li>
              <li>
                <p>
                  No refund will be given where a cancellation is attempted once
                  an Obby Gift Card has been fully redeemed, either via a
                  booking with a partner being booked or by being redeemed
                  against another purchase.
                </p>
              </li>
              <li>
                <p>
                  Please also note that where a cancellation is attempted once
                  an Obby Gift Card has been redeemed in part, either via a
                  booking with a partner being booked or by being redeemed
                  against another purchase. No refund will be given in respect
                  of the redeemed part of the Obby Gift Card.
                </p>
              </li>
              <li>
                <p>
                  Please also note that no refund will be given where a Gift
                  Card has been purchased via the “Gift This Class” feature and
                  the “suggested class” is no longer available. The Gift Card
                  will remain valid, until its expiry, and redeemable against
                  all classes on Obby, other than those mentioned in clause 3.
                  below.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>You cannot use an Obby Gift Card to:</p>
            <ul>
              <li>
                <p>
                  pay for Services at a Partner's own venue or on their own
                  website;
                </p>
              </li>
              <li>
                <p>purchase additional Obby Gift Cards; or</p>
              </li>
              <li>
                <p>
                  pay for Services on Obby or a Partner’s own website during any
                  Obby 'Sale days'; or
                </p>
              </li>
              <li>
                <p>exchange the balance on an Obby Gift Card for cash.</p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              Obby cannot guarantee the future availability of any class and
              therefore if an Obby Gift Card is bought via the “Gift This Class”
              feature that Gift Card can be used on any class on Obby, other
              than those mentioned in clause 3. above and can only be cancelled
              as stated in clause 2. above.{" "}
            </p>
          </li>
          <li>
            <p>
              Obby classes are subject to price increases at the discretion of
              our Partners. As such, Obby cannot guarantee the future price per
              person of any class and therefore if an Obby Gift Card is bought
              via the “Gift This Class” feature and the price increases the
              additional balance will have to be paid at the point of purchase.
              Alternatively, the Gift Card can be use on any class on Obby,
              other than those mentioned in clause 3. above and can only be
              cancelled as stated in clause 2. above.
            </p>
          </li>
          <li>
            <p>
              Your Obby Gift Card balance will remain valid for twelve months
              after the date of purchase. The exact expiry date will be included
              in the Gift Card email itself.{" "}
            </p>
          </li>
          <li>
            <p>
              If Obby ceases to trade or enters administration all Obby Gift
              Cards will become non-redeemable.
            </p>
          </li>
          <li>
            <p>
              In accordance with your Order, Obby Gift Cards will be delivered
              electronically.
            </p>
          </li>
        </ol>
      </div>
    </div>
  );
}
